import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an Optimisation icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OptimisationIcon width={12} />
 */
const OptimisationIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M8.114 19.429a16 16 0 0 1 -2.514 -1.371l-1.646 0.503A2.286 2.286 0 0 1 1.371 17.6l-0.457 
            -0.8a2.24 2.24 0 0 1 -0.274 -1.486 2.011 2.011 0 0 1 0.731 -1.326l1.257 -1.074a9.829 9.829 0 
            0 1 0 -2.971L1.371 8.869a1.989 1.989 0 0 1 -0.731 -1.303 2.171 2.171 0 0 1 0.274 -1.463l0.526 
            -0.846a2.217 2.217 0 0 1 1.074 -0.914c0.457 -0.183 0.914 -0.229 1.44 -0.046l1.646 0.503a10.057 
            10.057 0 0 1 2.514 -1.371L8.457 1.783A2.194 2.194 0 0 1 10.629 0h0.914c0.526 0 1.006 0.16 1.394 
            0.526 0.411 0.32 0.663 0.777 0.777 1.303l0.343 1.6a16 16 0 0 1 2.514 1.371l1.669 -0.526a2.286 
            2.286 0 0 1 2.583 0.96l0.434 0.823c0.274 0.457 0.366 0.96 0.297 1.486a2.011 2.011 0 0 1 -0.754 
            1.326l-1.257 1.074a9.829 9.829 0 0 1 0 2.971l1.257 1.074c0.411 0.366 0.686 0.777 0.754 1.303 
            0.069 0.503 -0.023 0.983 -0.297 1.44l-0.503 0.869c-0.274 0.411 -0.64 0.731 -1.097 0.914a2.057 
            2.057 0 0 1 -1.417 0.069l-1.669 -0.526a10.057 10.057 0 0 1 -2.514 1.371L13.714 21.074a2.194 
            2.194 0 0 1 -2.171 1.783h-0.914a2.057 2.057 0 0 1 -1.394 -0.503 2.331 2.331 0 0 1 -0.777 
            -1.326zM11.086 16c1.257 0 2.331 -0.457 3.223 -1.349 0.914 -0.891 1.349 -1.966 1.349 -3.223s-0.457
            -2.331 -1.349 -3.223C13.417 7.291 12.343 6.857 11.086 6.857s-2.331 0.457 -3.223 1.349c-0.914 
            0.891 -1.349 1.966 -1.349 3.223s0.457 2.331 1.349 3.223c0.891 0.914 1.966 1.349 3.223 1.349m17.143 
            27.2a10.286 10.286 0 0 1 -3.429 -1.943l-2.171 0.686c-0.686 0.229 -1.371 0.229 -2.057 -0.023s-1.211 
            -0.686 -1.6 -1.349l-0.617 -1.097a3.086 3.086 0 0 1 -0.411 -2.057c0.114 -0.754 0.457 -1.371 1.029 
            -1.874l1.714 -1.486a18.286 18.286 0 0 1 0 -4.114l-1.714 -1.531a3.017 3.017 0 0 1 -0.64 -3.886l0.64 
            -1.097a3.063 3.063 0 0 1 3.657 -1.371l2.171 0.686a10.286 10.286 0 0 1 3.429 -1.943l0.503 
            -2.354A3.04 3.04 0 0 1 31.771 16h1.371a3.04 3.04 0 0 1 3.017 2.446l0.526 2.354a10.286 10.286 0 
            0 1 3.429 1.943l2.171 -0.686c0.686 -0.229 1.371 -0.229 2.057 0.023s1.211 0.686 1.6 1.349l0.617 
            1.074c0.389 0.663 0.526 1.371 0.411 2.103s-0.457 1.371 -1.029 1.851l-1.714 1.486a18.286 18.286 
            0 0 1 0 4.114l1.714 1.531a3.017 3.017 0 0 1 0.617 3.886l-0.617 1.097a3.063 3.063 0 0 1 -3.657 
            1.371l-2.171 -0.686a10.286 10.286 0 0 1 -3.429 1.943l-0.526 2.354A3.04 3.04 0 0 1 33.143 
            48h-1.371a3.04 3.04 0 0 1 -3.04 -2.446zM32.457 38.857c1.897 0 3.52 -0.686 4.869 -2.011 1.326 
            -1.326 1.989 -2.949 1.989 -4.846s-0.686 -3.52 -2.011 -4.869A6.629 6.629 0 0 0 32.457 25.143c-1.897 
            0 -3.52 0.686 -4.869 2.011A6.629 6.629 0 0 0 25.6 32c0 1.897 0.686 3.52 2.011 4.869 1.326 1.326 
            2.949 1.989 4.846 1.989`}
        />
    </SvgIcon>
)

OptimisationIcon.defaultProps = defaultProps

export { OptimisationIcon }
